export const LocalStorage = <T>(storageKey = '') => {
  const getItem = (defaultValue: object, key = storageKey): T => {
    const item = localStorage.getItem(key)
    if (item) return JSON.parse(item) as T
    return defaultValue as T
  }

  const setItem = (value: T, key = storageKey): void => {
    localStorage.setItem(key, JSON.stringify(value))
  }

  const removeItem = (key = storageKey) => {
    localStorage.removeItem(key)
  }

  const setAndGetItem = (value: T, defaultValue: any, key = storageKey): T => {
    setItem(value, key)
    return getItem(defaultValue, key)
  }

  const clear = () => {
    localStorage.clear()
  }

  return {
    getItem,
    setItem,
    removeItem,
    setAndGetItem,
    clear,
  }
}
